

export function start(detail){   //console.log('leftnav>', detail) 

      obj[detail.act].start(detail)

}/**/


const obj = {
      setDarkTheme:         { start: (detail)=>{  setDarkTheme()              }},
      removeDarkTheme:      { start: (detail)=>{  removeDarkTheme()           }},

}/**/



//funcion para setear el tema oscuro
export function setDarkTheme() {  //console.log('expand leftnav')

    localStorage.setItem('darkTheme', 'true')
    const body = document.querySelector('body')
    body.classList.add('darkTheme')

}

//funcion para remover el tema oscuro
export function removeDarkTheme() {
    localStorage.removeItem('darkTheme')
    const body = document.querySelector('body')
    body.classList.remove('darkTheme')

}

//funcion para verificar si el tema oscuro esta seteado
export function checkIfExistsDarkTheme() {  //console.log('leftnav selectById', leftnav) 
    if (localStorage.getItem('darkTheme') === 'true') {
        return true
    } else {
        return false
    }
}






